module.exports = __webpack_public_path__ + "static/index/img/baikal-704.054dc7fe.jpg";